import React from "react";
import Duration from "app/components/shared/Duration";
import UserAvatar from "app/components/shared/UserAvatar";
import { getDateString } from "app/lib/date";
import { Build } from "app/stores/BuildsStore";

export function getDurationValues(build: Build) {
  switch (build.state) {
    case "passed":
    case "failed":
    case "blocked":
      return {
        // @ts-expect-error - TS2339 - Property 'startedAt' does not exist on type 'Build'.
        from: build.startedAt,
        // @ts-expect-error - TS2339 - Property 'finishedAt' does not exist on type 'Build'.
        to: build.finishedAt,
      };
    case "failing":
    case "started":
      return {
        // @ts-expect-error - TS2339 - Property 'startedAt' does not exist on type 'Build'.
        from: build.startedAt,
        live: true,
      };
    case "canceled":
      // @ts-expect-error - TS2339 - Property 'startedAt' does not exist on type 'Build'.
      if (build.startedAt) {
        return {
          // @ts-expect-error - TS2339 - Property 'startedAt' does not exist on type 'Build'.
          from: build.startedAt,
          // @ts-expect-error - TS2339 - Property 'canceledAt' does not exist on type 'Build'.
          to: build.canceledAt,
        };
      }
      return null;
    case "scheduled":
      return {
        // @ts-expect-error - TS2339 - Property 'scheduledAt' does not exist on type 'Build'.
        from: build.scheduledAt,
        live: true,
      };
    default:
      return null;
  }
}

export function getDurationPrefix(build: Build) {
  switch (build.state) {
    case "passed":
      return "Passed in";
    case "failing":
      return "Running for";
    case "failed":
      return "Failed in";
    case "blocked":
      return "Passed in";
    case "canceled":
      // @ts-expect-error - TS2339 - Property 'cancelReason' does not exist on type 'Build'.
      if (build.cancelReason === "build_skipping") {
        // @ts-expect-error - TS2339 - Property 'startedAt' does not exist on type 'Build'.
        return build.startedAt
          ? "Canceled automatically after"
          : "Canceled automatically";
      }

      // @ts-expect-error - TS2339 - Property 'startedAt' does not exist on type 'Build'.
      return build.startedAt ? "Canceled after" : "Canceled";
    case "scheduled":
      return "Waiting for";
    case "started":
      return "Running for";
    case "creating":
      return "Creating";
    case "canceling":
      return "Canceling";
    case "skipped":
      return "Skipped";
    case "not_run":
      return "Not run";
    default:
      return null;
  }
}

export function getDurationSuffix(build: Build) {
  switch (build.state) {
    case "failing":
      return "and failing";
    case "blocked":
      return "and blocked";
    default:
      return null;
  }
}

function BuildDuration({
  build,
  durationFormat,
}: {
  durationFormat: "Short" | "Micro";
  build: Build;
}) {
  const DurationFormat = Duration[durationFormat];

  const duration = getDurationValues(build);
  const suffix = getDurationSuffix(build);
  const prefix = getDurationPrefix(build);

  let prefixNode: React.ReactNode = null;

  if (build.state === "canceled") {
    // @ts-expect-error - TS2339 - Property 'cancelReason' does not exist on type 'Build'.
    if (build.cancelReason === "build_skipping") {
      // When the build was skipped, include a tooltip to explain why.
      // @ts-expect-error - TS2339 - Property 'canceledAt' does not exist on type 'Build'.
      const canceledAt = getDateString(build.canceledAt);
      const title = `This build was automatically canceled by your Build Skipping settings at ${canceledAt}`;
      prefixNode = <span title={title}>{prefix}</span>;
      // @ts-expect-error - TS2339 - Property 'cancelledBy' does not exist on type 'Build'.
    } else if (build.cancelledBy) {
      // When the build was canceled by a user, include their avatar and name and show canceled time on hover.
      prefixNode = (
        // @ts-expect-error - TS2339 - Property 'canceledAt' does not exist on type 'Build'.
        <span title={build.canceledAt}>
          <UserAvatar
            user={{
              // @ts-expect-error - TS2339 - Property 'cancelledBy' does not exist on type 'Build'.
              name: build.cancelledBy.name,
              avatar: {
                // @ts-expect-error - TS2339 - Property 'cancelledBy' does not exist on type 'Build'.
                url: build.cancelledBy.avatar,
              },
            }}
            style={{
              width: 20,
              height: 20,
              marginRight: 2,
            }}
            suppressAltText={true}
          />
          {/* @ts-expect-error - TS2339 - Property 'cancelledBy' does not exist on type 'Build'. */}
          <strong className="semi-bold">{build.cancelledBy.name}</strong>{" "}
          {prefix && prefix.toLowerCase()}
        </span>
      );
    } else {
      // Otherwise, display the canceled time on hover.
      // @ts-expect-error - TS2339 - Property 'canceledAt' does not exist on type 'Build'.
      prefixNode = <span title={build.canceledAt}>{prefix}</span>;
    }
  }

  return (
    <span>
      {prefixNode || prefix} {duration && <DurationFormat {...duration} />}{" "}
      {suffix}
    </span>
  );
}

BuildDuration.defaultProps = {
  durationFormat: "Short",
};

export default BuildDuration;
